module.exports = __webpack_public_path__ + "img/calc.109f516.png";